<style lang="stylus">
    .gantt_box
      align-content flex-start
      width: 676px
      //height: 366px
      padding: 12px 20px
      margin: 0 auto
      max-height 600px
      overflow scroll
      .gantt_rows_tips{
        color: #757575;
        display: flex;
        align-items: center;
      }
      .gantt_add{
        cursor: pointer;
        margin-right: 10px;
        color:#757575;
        &:hover{
          color:var(--svg-color-black);
        }
      }
      .gantt_title {
        margin-left: 3px
        margin-bottom: 12px
        font-size: 14px
        color var(--text-color-black)
        line-height 16px
      }
      .gantt_rows + .gantt_rows{
        margin-top: 10px;
      }
      .gantt_rows
        display flex
        position relative
        .gantt_polygon
          position absolute
          right 8px
          top 10px
          width 6px
          height 4px
          pointer-events none
        .gantt_rows_title
          line-height: 20px
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        .gantt_rows_datebox
          position: relative;
          width: 134px
          .gantt_date
            width 134px

          .ivu-input-suffix
            display none
        .gantt_rows_dropdown_box
          position: relative;
          float: right
          //width: 134px
          height: 24px
          .ivu-dropdown .ivu-select-dropdown
            overflow-y: auto
            overflow-x: hidden
            max-height: 400px
        .gantt_rows_dropdown_box_content
          width: 134px
          height: 24px
          line-height: 20px
          border: 1px solid var(--border-color-float-tool-common)
          text-align: left
          padding-left: 8px
          padding-right: 12px
          font-size: 12px
          color: #515a6e
          border-radius: 4px
          transition: border .2s
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          .prefix{
            left: -8px
            position: relative;
            display: inline-block;
            padding: 0 8px;
            border-right:1px solid var(--border-color-float-tool-common);
            background-color: var(--bg-color-base-7);
          }
        .gantt_rows_dropdown_box_content:hover
          border-color: var(--themeColor)
      .gantt_setdate_box
        position: relative
        border: 1px solid var(--border-color-box-6);
        border-radius 6px
        padding: 16px
        >input
          height 20px

        .gantt_rows_timebox
          margin-left: 8px
          position: relative
          display inline-block
          .gantt_time
            width 64px
            .ivu-select-dropdown
                .ivu-time-picker-cells-list
                    border-left-color var(--border-color-ivu-time-picker-cells-list)
                .ivu-time-picker-cells-cell:hover
                    background-color var(--bg-color-ivu-select-item-hover)
                .ivu-time-picker-cells-cell-selected, .ivu-time-picker-cells-cell-selected:hover
                    background-color var(--bg-color-ivu-select-item-hover)
                    color var(--themeHover)
          .ivu-input-suffix
            display none
        .gantt_checkbox,.gantt_rows_dropdown_box
          display: flex;
          justify-content: center;
          align-items: center;
          .ivu-checkbox-group{
            display: inline-block;
          }
          .ivu-checkbox{
            display none
          }
          .ivu-checkbox-wrapper,.ivu-radio-wrapper{
            text-align: center;
            line-height: 28px;
            min-width: 60px;
            height: 28px;
            border-width: 1px 1px 1px 1px;
            border-style: solid;
            border-color: var(--border-color-box-6);
            margin-right: 0;
            box-shadow:none;
            background-color var(--bg-color-tertiary)
            color var(--text-color-black)
            &:hover:not(.ivu-checkbox-wrapper-checked):not(.ivu-radio-wrapper-checked){
              background: var(--bg-color-ivu-checkbox-wrapper-hover);
              border-color: var(--border-color-box-6);
              color: var(--text-color-primary);
            }
            &.ivu-radio-focus{
              box-shadow none;
              &:after{
                display none
              }
            }
            &.ivu-checkbox-wrapper-checked,
            &.ivu-radio-wrapper-checked{
              background: var(--theme-color-10);
              border-color: var(--theme-color-40);
              color: var(--themeColor);
            }
            &:nth-child(1){
              border-radius: 6px 0 0 6px;
            }
            &:last-child{
              border-radius: 0 6px 6px 0;
            }
          }
        .ivu-radio-group-button .ivu-radio-wrapper:after, .ivu-radio-group-button .ivu-radio-wrapper:before {
            background var(--border-color-float-tool-common)
        }
        .gantt_split {
          width 1px
          height 20px
          background var(--border-color-box-6)
          margin-left 8px
        }
        .gantt_short
          display: inline-flex;
          .gantt_rows_title
            width: max-content;
            min-width 80px
            margin-right 16px
          .gantt_rows_dropdown_box{
            width: max-content;
            .ivu-dropdown-item {
              color: var(--text-color-primary) !important
            }
          }
          .gantt_rows_dropdown_box_content
            width 110px
            padding-right 12px
            color: var(--text-color-primary) !important
            border-radius 6px
      .gantt_row
        //width 225px
        //display flex
        flex-wrap wrap
        align-content space-between
        margin-bottom 12px
        .ivu-input
          border-color var(--border-color-box-6);
          color: var(--text-color-primary)
    .ganttbox_up
      width 100%
      .workindDays_box{

      }
    .ganttbox_down
      display flex
      justify-content space-between
      width 100%
      height 110px
      .otherDays_row
        width 468px
        .otherDays_box
          width 468px
          height 110px
          .gantt_rows
            width 100%
            height 93px
            margin 0
            margin-top 15px
            padding 0 10px 0 20px

      .gantt_row
        .format_box
          height 110px
    .ganttoption_dialog
      padding-bottom 24px
      .dialog-btnbox-normal
        padding 0 20px
    .gantt_otherDays_btn
      left 2px
      top 15px
      display flex
      flex-wrap wrap
      justify-content center
      width 20px
      height 37px
      z-index 1
      margin-right:16px

      >div
        cursor: pointer;
        width 24px
        height 24px
        user-select none
        color var(--svg-color-gray-42);
        margin-bottom: 10px;
        border: 1px solid transparent;
        padding: 3px
        &:hover{
          color var(--color-black)
          background: var(--bg-color-ganttotherday-btn);
          border: 1px solid var(--border-color-gray-12);
          border-radius: 5.33333px;
        }
</style>

<template>
    <Dialog :title="$t('title')" :isShow="true" :mask="true" :showFooter="true" :media="false" class="ganttoption_dialog" @ok="ok" @close="cancel">
        <div class="gantt_box" @click="cancelSelect">
            <div class="ganttbox_up">
                <div class="gantt_row">
                    <p class="gantt_title">{{ $t("projectDuration") }}</p>
                    <div class="gantt_setdate_box">
                        <div class="gantt_rows">
                            <p class="gantt_rows_tips">{{ $t("tips1") }}</p>
                        </div>
                        <div class="gantt_rows">
                            <p class="gantt_rows_title" style="margin-right: 16px" :title="$t('startDate')">{{ $t("startDate") }} :</p>
                            <div class="gantt_rows_datebox">
                                <DatePicker
                                    class="gantt_date"
                                    size="small"
                                    @on-change="selectStartDate"
                                    v-model="StartDateName"
                                    :clearable="false"
                                    type="date"
                                    placeholder="Select date"
                                ></DatePicker>
                                <iconSymbol class="gantt_polygon" name="polygon" />
                            </div>
                            <p class="gantt_rows_title" style="margin: 0 8px" :title="$t('to')">{{ $t("to") }}</p>
                            <div class="gantt_rows_datebox">
                                <DatePicker
                                    class="gantt_date"
                                    size="small"
                                    @on-change="selectEndDate"
                                    v-model="EndDateName"
                                    :clearable="false"
                                    type="date"
                                    placeholder="Select date"
                                ></DatePicker>
                                <iconSymbol class="gantt_polygon" name="polygon" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="gantt_row">
                    <p class="gantt_title">{{ $t("workingDays") }}</p>
                    <div class="gantt_setdate_box workindDays_box">
                        <div class="gantt_rows">
                            <p class="gantt_rows_tips">{{ $t("tips2") }}</p>
                        </div>
                        <div class="gantt_rows">
                            <div class="gantt_checkbox">
                                <CheckboxGroup v-model="WorkingDay" @on-change="selectWorkingDay">
                                    <Checkbox :key="index" v-for="(item, index) in WorkingDayList" :label="item" v-model="WorkingDayBoolean[index]">
                                        {{ $t(item) }}
                                    </Checkbox>
                                </CheckboxGroup>
                                <div class="gantt_split"></div>
                                <div class="gantt_rows_timebox">
                                    <TimePicker
                                        class="gantt_time"
                                        size="small"
                                        @on-change="selectStartTime"
                                        v-model="StartTimeName"
                                        format="HH:mm"
                                        :placeholder="$t('Select time')"
                                    ></TimePicker>
                                    <iconSymbol class="gantt_polygon" name="polygon" />
                                </div>
                                <span style="margin-left: 10px">{{ $t("to") }}</span>
                                <div class="gantt_rows_timebox">
                                    <TimePicker
                                        class="gantt_time"
                                        size="small"
                                        @on-change="selectEndTime"
                                        v-model="EndTimeName"
                                        format="HH:mm"
                                        :placeholder="$t('Select time')"
                                    ></TimePicker>
                                    <iconSymbol class="gantt_polygon" name="polygon" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="gantt_row otherDays_row">
                    <p class="gantt_title">{{ $t("setOtherDays") }}</p>
                    <div class="gantt_setdate_box otherDays_box">
                        <div v-show="ganttOtherDaysData.length === 0">
                            <div class="gantt_rows">
                                <svg @click.stop="addGanttData" class="gantt_add" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clip-path="url(#clip0_13046_306887)">
                                        <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2" />
                                        <path d="M6 8H10" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                        <path d="M8 6L8 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_13046_306887">
                                            <rect width="16" height="16" fill="currentColor" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span class="gantt_rows_tips">{{ $t("tips3") }}</span>
                            </div>
                        </div>
                        <div v-show="ganttOtherDaysData.length !== 0">
                            <div class="gantt_rows">
                                <p class="gantt_rows_tips">{{ $t("tips3") }}</p>
                            </div>
                            <div class="gantt_rows">
                                <div class="gantt_otherDays_btn">
                                    <Tooltip :content="$t('deleteRow')" :placement="'right'" theme="light">
                                        <div class="otherDays_btn_del" @click.stop="delGannttData">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <g clip-path="url(#clip0_14472_311504)">
                                                    <path d="M5 8H11" stroke="currentColor" stroke-linecap="round" />
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                                                        fill="currentColor"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_14472_311504">
                                                        <rect width="16" height="16" fill="currentColor" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </Tooltip>
                                    <Tooltip :content="$t('addRow')" :placement="'right'" theme="light" :style="{}">
                                        <div class="otherDays_btn_add" @click.stop="addGanttData">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <g clip-path="url(#clip0_14472_311503)">
                                                    <path d="M5 8L11 8" stroke="currentColor" stroke-linecap="round" />
                                                    <path d="M8 5L8 11" stroke="currentColor" stroke-linecap="round" />
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                                                        fill="currentColor"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_14472_311503">
                                                        <rect width="16" height="16" fill="currentColor" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </Tooltip>
                                </div>
                                <div class="gantt_rows">
                                    <GanttOtherDays
                                        style="width: 520px"
                                        ref="ganttDay"
                                        :data="ganttOtherDaysData"
                                        @selectGanttLine="selectGanttLine"
                                        @changeGanttData="changeGanttData"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="gantt_row">
                <p class="gantt_title">{{ $t("format") }}</p>
                <div class="gantt_setdate_box format_box">
                    <div class="gantt_rows">
                        <span class="gantt_rows_tips">{{ $t("tips4") }}</span>
                    </div>
                    <div class="gantt_rows gantt_short">
                        <p class="gantt_rows_title" :title="$t('dateFormat')">{{ $t("dateFormat") }} :</p>
                        <div class="gantt_rows_dropdown_box">
                            <Dropdown trigger="click" @on-click="selectDateFormat" placement="bottom-start" :transfer="true">
                                <div class="gantt_rows_dropdown_box_content" href="javascript:void(0)" v-text="DateFormatName">
                                    <Icon type="ios-arrow-down"></Icon>
                                </div>
                                <DropdownMenu slot="list">
                                    <DropdownItem :name="index" :key="index" v-for="(item, index) in DateFormatList">{{ item }}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        <iconSymbol class="gantt_polygon" name="polygon" />
                    </div>
                    <div class="gantt_rows gantt_short" style="margin-left: 20px">
                        <p class="gantt_rows_title" :title="$t('durationFormat')">{{ $t("durationFormat") }} :</p>
                        <div class="gantt_rows_dropdown_box">
                            <Dropdown trigger="click" @on-click="selectDurationFormat" placement="bottom-start" :transfer="true">
                                <div class="gantt_rows_dropdown_box_content" href="javascript:void(0)" v-text="DurationFormatName">
                                    <Icon type="ios-arrow-down"></Icon>
                                </div>
                                <DropdownMenu slot="list">
                                    <DropdownItem :name="index" :key="index" v-for="(item, index) in DurationFormatList">{{ item }}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        <iconSymbol class="gantt_polygon" name="polygon" />
                    </div>
                    <br />
                    <div class="gantt_rows gantt_short">
                        <p class="gantt_rows_title" :title="$t('percentFormat')">{{ $t("percentFormat") }} :</p>
                        <div class="gantt_rows_dropdown_box">
                            <Dropdown trigger="click" @on-click="selectPercentFormat" placement="bottom-start" :transfer="true">
                                <div class="gantt_rows_dropdown_box_content" href="javascript:void(0)" v-text="PercentFormatName">
                                    <Icon type="ios-arrow-down"></Icon>
                                </div>
                                <DropdownMenu slot="list">
                                    <DropdownItem :name="index" :key="index" v-for="(item, index) in PercentFormatList">{{ item }}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        <iconSymbol class="gantt_polygon" name="polygon" />
                    </div>
                    <div class="gantt_rows gantt_short" style="margin-left: 20px">
                        <p class="gantt_rows_title" :title="$t('currencyUnit')">{{ $t("currencyUnit") }} :</p>
                        <div class="gantt_rows_dropdown_box">
                            <Dropdown trigger="click" @on-click="selectUnit" placement="bottom-start" :transfer="true">
                                <div class="gantt_rows_dropdown_box_content" href="javascript:void(0)">
                                    {{ currencyName }}
                                </div>
                                <DropdownMenu slot="list">
                                    <DropdownItem :name="index" :key="index" v-for="(item, index) in renderUnitList">{{ item }}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            <iconSymbol class="gantt_polygon" name="polygon" />
                        </div>
                        <div class="gantt_rows_dropdown_box" style="margin-left: 10px">
                            <Dropdown trigger="click" @on-click="selectFormat" placement="bottom-start" :transfer="true">
                                <div class="gantt_rows_dropdown_box_content" href="javascript:void(0)">
                                    {{ formatName }}
                                </div>
                                <DropdownMenu slot="list">
                                    <DropdownItem :name="index" :key="index" v-for="(item, index) in FormatList">
                                        {{ item }}
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            <iconSymbol class="gantt_polygon" name="polygon" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="gantt_row">
                <p class="gantt_title">{{ $t("dateUnit") }}</p>
                <div class="gantt_setdate_box">
                    <div class="gantt_rows">
                        <p class="gantt_rows_tips">{{ $t("tips5") }}</p>
                    </div>
                    <div class="gantt_rows">
                        <div class="gantt_rows_dropdown_box">
                            <RadioGroup :value="MinorNum" type="button" @on-change="selectMinor">
                                <Radio :label="4">{{ $t(DataUnitListTwo[4]) }}</Radio>
                                <Radio :label="3">{{ $t(DataUnitListTwo[3]) }}</Radio>
                                <Radio :label="2">{{ $t(DataUnitListTwo[2]) }}</Radio>
                                <Radio :label="1">{{ $t(DataUnitListTwo[1]) }}</Radio>
                                <Radio :label="0">{{ $t(DataUnitListTwo[0]) }}</Radio>
                                <Radio :label="5">{{ $t(DataUnitListTwo[5]) }}</Radio>
                            </RadioGroup>
                        </div>
                    </div>
                    <!--          <div class="gantt_rows">-->
                    <!--            <p class="gantt_rows_title" :title="$t('majorUnit')"> {{ $t('majorUnit') }} :</p>-->
                    <!--            <div class="gantt_rows_dropdown_box">-->
                    <!--              <Dropdown trigger="click" @on-click="selectMajor" placement="bottom-start">-->
                    <!--                <div class="gantt_rows_dropdown_box_content" href="javascript:void(0)" v-text="$t(MajorName)">-->
                    <!--                  <Icon type="ios-arrow-down"></Icon>-->
                    <!--                </div>-->
                    <!--                <DropdownMenu slot="list">-->
                    <!--                  <DropdownItem :name="index" :key='index' v-for="(item,index) in DataUnitList">{{ $t(item) }}</DropdownItem>-->
                    <!--                </DropdownMenu>-->
                    <!--              </Dropdown>-->
                    <!--            </div>-->
                    <!--            <iconSymbol class="gantt_polygon" name="polygon" />-->
                    <!--          </div>-->
                    <!--          <div class="gantt_rows">-->
                    <!--            <p class="gantt_rows_title" :title="$t('minorUnit')"> {{ $t('minorUnit') }} :</p>-->
                    <!--            <div class="gantt_rows_dropdown_box">-->
                    <!--              <Dropdown trigger="click" @on-click="selectMinor" placement="bottom-start">-->
                    <!--                <div class="gantt_rows_dropdown_box_content" href="javascript:void(0)" v-text="$t(MinorName)">-->
                    <!--                  <Icon type="ios-arrow-down"></Icon>-->
                    <!--                </div>-->
                    <!--                <DropdownMenu slot="list">-->
                    <!--                  <DropdownItem :name="index" :key='index' v-for="(item,index) in DataUnitListTwo" v-if="index+1 <= MajorNum ? false:true">{{ $t(item) }}</DropdownItem>-->
                    <!--                </DropdownMenu>-->
                    <!--              </Dropdown>-->
                    <!--            </div>-->
                    <!--            <iconSymbol class="gantt_polygon" name="polygon" />-->
                    <!--          </div>-->
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    declare var EDFormat: any;
    declare var EDOpeAssist: any;
    declare var eMsgType: any;
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";
    import GanttOtherDays from "./GanttOtherDays.vue";
    enum unitType {
        "None" = 0,
        AUD = 1,
        CAD = 2,
        DKK = 3,
        EUR = 4,
        HKD = 5,
        JPY = 6,
        GBP = 7,
        SEK = 8,
        USD = 9,
        CNY = 10,
        INR = 11,
        KRW = 12,
        MYR = 13,
        MXN = 14,
        ZAR = 15,
    }

    @Component({
        components: {
            Dialog,
            GanttOtherDays,
        },
    })
    export default class GanttOption extends Vue {
        MajorName: string = "Year";
        MinorName: string = "Quarter";
        DateFormatName: string = "2018-01-31";
        map_DateFormatName: string = "yyyy-MM-dd";
        PercentFormatName: string = "0%";
        DurationFormatName: any = "1.2w";
        map_DurationFormatName: string = '[ww] "w."';
        StartDateName: string = "";
        EndDateName: string = "";
        showStartDateName: string = "";
        showEndDateName: string = "";
        StartTimeName: string = "";
        EndTimeName: string = "";
        UnitName: string = "CNY";
        FormatName: string = "#,###0.00";

        WorkingDay: Array<string> = []; // 选中星期*字符串数组
        WorkingDayBoolean: Array<boolean> = [false, false, false, false, false, false, false]; // 选中星期*布尔数组
        initWorkingDayBoolean: Array<boolean> = []; // 初始化的数据备份
        MajorNum: number = 0;
        MinorNum: number = 1;
        DateFormatNum: number = 0;
        PercentFormatNum: number = 0;
        DurationFormatNum: number = 0;
        UnitNum: number = 0;
        FormatNum: number = 0;

        WorkingDayList: Array<string> = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        DataUnitList: Array<string> = ["Year", "Quarter", "Month", "Week", "Day"];
        DataUnitListTwo: Array<string> = ["Quarter", "Month", "Week", "Day", "Hour", "HalfYear"];
        DateFormatList: Array<string> = [];
        map_DateFormatList: Array<string> = [
            "yyyy-MM-dd",
            "yyyy/M/d",
            "M/d/yyyy",
            "M/d/yy",
            "d/M/yyyy",
            "d/M/yy",
            "M.d.yyyy",
            "d.M.yyyy",
            "yy-M-d",
            "MM-dd-yy",
            "MMMM d,yyyy",
            "dddd,MMMM dd,yyyy",
            "d MMMM yyyy",
            "d-MMM-yy",
            "MMM.d,yy",
            // 'MMMM yy',
            // 'MMM-yy',
            // 'yyyy',
            // 'MMM',
            "M/d/yyyy h:mm:ss ap",
            "M/d/yyyy h:mm ap",
            "d/M/yyyy h:mm:ss ap",
            "d/M/yyyy h:mm ap",
            // 'h:mm ap',
            // 'h:mm:ss ap',
            // 'hh:mm',
            // 'hh:mm:ss',
            // 'hh',
            // 'mm',
            // 'ss',
        ];
        PercentFormatList: Array<string> = ["0%", "0.0%", "0.00%", "0.000%"];
        get map_DurationFormatList() {
            let formatList: Array<string> = [];
            if (this.lang == "zh") {
                formatList = ["[ww] 周", "[w] 周 [d] 天", "[dd] 天", "[d] 天 [h] 小时", "[h] 小时", "[hh] 小时"];
            } else {
                formatList = ["[ww] w.", "[w] w. [d] d.", "[dd] d.", "[d] d. [h] h.", "[h] h.", "[hh] h."];
            }
            return formatList;
        }
        UnitList: Array<string> = [
            "None",
            "AUD[$A.][澳大利亚元]",
            "CAD[$][加元]",
            "DKK[D.Kr.][丹麦克朗]",
            "EUR[€][欧元]",
            "HKD[HK$][港元]",
            "JPY[¥][日元]",
            "GBP[£][英镑]",
            "SEK[S.Kr.][瑞典克朗]",
            "USD[$][美元]",
            "CNY[￥][元]",
            "INR[Re.][卢比]",
            "KRW[KRW][韩元]",
            "MYR[M.$][马元]",
            "MXN[$][墨西哥比索]",
            "ZAR[R.][兰特]",
        ];
        get renderUnitList() {
            if (this.lang !== "zh") {
                return this.UnitList.map((item) => item.replace(/\[[\u4e00-\u9fff]+\]/g, ""));
            }
            return this.UnitList;
        }
        FormatList_Text: Array<string> = ["AUD", "CAD", "DKK", "EUR", "HKD", "JPY", "GBP", "SEK", "USD", "CNY", "INR", "KRW", "MYR", "MXN", "ZAR"];
        FormatList_Symbol: Array<string> = ["$A.", "$", "D.Kr.", "€", "HK$", "¥", "£", "S.Kr.", "$", "￥", "Re.", "KRW", "M.$", "$", "R."];
        FormatList: Array<string> = [""];
        ganttOtherDaysData = [
            // {
            //     name: '小明',
            //     start: 1622443377562,
            //     end: 1622443377562,
            // },
        ];
        editIndex = -1;
        get FormatList_Name() {
            return [
                this.$t("AUD"),
                this.$t("CAD"),
                this.$t("DKK"),
                this.$t("EUR"),
                this.$t("HKD"),
                this.$t("JPY"),
                this.$t("GBP"),
                this.$t("SEK"),
                this.$t("USD"),
                this.$t("CNY"),
                this.$t("INR"),
                this.$t("KRW"),
                this.$t("MYR"),
                this.$t("MXN"),
                this.$t("ZAR"),
            ];
        }
        confirmChangeGanttData() {
            let arr = [];
            for (let item of this.ganttOtherDaysData) {
                // if(item.otherdays_name && item.otherdays_start && item.otherdays_end) {
                if (item && item.otherdays_start && item.otherdays_end) {
                    let data = [];
                    data.push(item.otherdays_name);
                    data.push(new Date(item.otherdays_start).toLocaleDateString().replace(/\//g, "-"));
                    data.push(new Date(item.otherdays_end).toLocaleDateString().replace(/\//g, "-"));
                    arr.push(data);
                }
            }
            window["_view"].setGanttExceptDate(arr);
        }
        changeGanttData(obj) {
            console.log(obj);
            if (obj.data) {
                this.ganttOtherDaysData.splice(obj.index, 1, obj.data);
            } else {
                this.ganttOtherDaysData.splice(obj.index, 1);
            }
        }
        selectGanttLine(index) {
            this.editIndex = index;
        }
        addGanttData() {
            this.ganttOtherDaysData.push({
                otherdays_name: "",
                otherdays_start: "",
                otherdays_end: "",
            });
            (this.$refs.ganttDay as any).updateTempData();
        }
        delGannttData() {
            if (this.editIndex == -1) return;
            this.ganttOtherDaysData.splice(this.editIndex, 1);
            this.editIndex = -1;
            (this.$refs.ganttDay as any).updateTempData();
        }
        cancelSelect(e) {
            let table = (this.$refs.ganttDay as any).$el as HTMLElement;
            if (!table.contains(e.target)) {
                (this.$refs.ganttDay as any).handleCancel();
            }
        }
        get DurationFormatList() {
            return [this.$t("1.2 w."), this.$t("1 w. 1 d."), this.$t("8.2 d."), this.$t("8 d. 5 h."), this.$t("197 h."), this.$t("197.5 h.")];
        }

        // 组件方法也可以直接声明为实例的方法
        showBox() {
            let pGantt: any = window["_view"].getGantt(); // type: EDGantt
            if (pGantt) {
                this.selectMajor(pGantt._eMajor);
                this.selectMinor(pGantt._eMinor - 1);
                for (let i = 0; i < pGantt._workDays.length; i++) {
                    if (i === 0) this.WorkingDayBoolean[6] = pGantt._workDays[0];
                    else this.WorkingDayBoolean[i - 1] = pGantt._workDays[i];
                }
                this.initWorkingDayBoolean = this.WorkingDayBoolean.slice(0); // 初始化备份数组
                this.WorkingDay = [];
                for (let i = 0; i < this.WorkingDayBoolean.length; i++) {
                    if (this.WorkingDayBoolean[i]) {
                        this.WorkingDay.push(this.WorkingDayList[i]);
                    }
                }
                //this.selectDateFormat(EDFormat.dayFormat(pGantt._dSDate, pGantt._strFmtDate));
                let dateIndex = this.map_DateFormatList.indexOf(pGantt._strFmtDate) == -1 ? 0 : this.map_DateFormatList.indexOf(pGantt._strFmtDate);
                this.selectDateFormat(dateIndex);
                this.PercentFormatName = pGantt._strFmtPercent;
                //this.DurationFormatName = EDFormat.numberToString(8.23, pGantt._strFmtDuration, EDProperty.eType.Duration);
                let durFormatStr: string = pGantt._strFmtDuration;
                let durFmtIndex = -1;
                if (durFormatStr.indexOf("[ww]") != -1) durFmtIndex = 0;
                else if (durFormatStr.indexOf("[w]") != -1) durFmtIndex = 1;
                else if (durFormatStr.indexOf("[dd]") != -1) durFmtIndex = 2;
                else if (durFormatStr.indexOf("[d]") != -1) durFmtIndex = 3;
                else if (durFormatStr.indexOf("[h]") != -1) durFmtIndex = 4;
                else if (durFormatStr.indexOf("[hh]") != -1) durFmtIndex = 5;
                else durFmtIndex = 0;

                // this.selectDurationFormat(this.map_DurationFormatList.indexOf(pGantt._strFmtDuration));
                this.selectDurationFormat(durFmtIndex);
                this.UnitName = pGantt._curUnit;
                this.FormatName = pGantt._strFmtCurrency;
                this.StartDateName = EDFormat.dayFormat(pGantt._dSDate, "yyyy-MM-dd"); //由于特殊格式没法解析显示，先用正常格式代替
                this.EndDateName = EDFormat.dayFormat(pGantt._dEDate, "yyyy-MM-dd");
                this.showStartDateName = this.StartDateName;
                this.showEndDateName = this.EndDateName;
                console.log("Option---------StartDateName=", this.StartDateName, EDFormat.dayFormat(pGantt._dSDate, "yyyy-MM-dd"));

                let nHour = parseInt((pGantt._nSMinutes / 60).toString());
                let nMinute = pGantt._nSMinutes - nHour * 60;
                let strHour = nHour.toString();
                if (strHour.length === 1) strHour = "0" + strHour;
                let strMinute = nMinute.toString();
                if (strMinute.length === 1) strMinute = "0" + strMinute;
                this.StartTimeName = strHour + ":" + strMinute;

                nHour = parseInt((pGantt._nEMinutes / 60).toString());
                nMinute = pGantt._nEMinutes - nHour * 60;
                strHour = nHour.toString();
                if (strHour.length === 1) strHour = "0" + strHour;
                strMinute = nMinute.toString();
                if (strMinute.length === 1) strMinute = "0" + strMinute;
                this.EndTimeName = strHour + ":" + strMinute;
            }

            if (unitType[this.UnitName] == 0) {
                this.FormatList = ["1,980.00", "0.00"];
                this.FormatName = "1,980.00";
            } else {
                this.FormatList = [
                    `"${this.FormatList_Symbol[unitType[this.UnitName] - 1]}" 1,980.00`,
                    `"${this.FormatList_Text[unitType[this.UnitName] - 1]}" 1,980.00`,
                    `1,980.00 "${this.FormatList_Text[unitType[this.UnitName] - 1]}"`,
                    `1,980.00 "${this.FormatList_Name[unitType[this.UnitName] - 1]}"`,
                    `"${this.FormatList_Symbol[unitType[this.UnitName] - 1]}" 1980.00`,
                    `"${this.FormatList_Text[unitType[this.UnitName] - 1]}" 1980.00`,
                    `1980.00 "${this.FormatList_Text[unitType[this.UnitName] - 1]}"`,
                    `"${this.FormatList_Name[unitType[this.UnitName] - 1]}" 1980.00`,
                ];
                this.FormatName = this.FormatList[this.FormatNum];
            }
        }
        ok() {
            // 确定行列选择
            this.confirmChangeGanttData();
            let bWdays: Array<boolean> = [false, true, true, true, true, true, false];
            bWdays[0] = this.WorkingDayBoolean[6];
            for (let i = 0; i < bWdays.length; i++) {
                if (i === 0) bWdays[0] = this.WorkingDayBoolean[6];
                else bWdays[i] = this.WorkingDayBoolean[i - 1];
            }
            this.initWorkingDayBoolean = this.WorkingDayBoolean.slice(0); // 更新备份数组
            if (!bWdays[0] && !bWdays[0] && !bWdays[1] && !bWdays[2] && !bWdays[3] && !bWdays[4] && !bWdays[5] && !bWdays[6]) {
                bWdays[0] = false;
                bWdays[1] = true;
                bWdays[2] = true;
                bWdays[3] = true;
                bWdays[4] = true;
                bWdays[5] = true;
                bWdays[6] = false;
            }
            let pGantt: any = window["_view"].getGantt(); // type: EDGantt
            if (pGantt) {
                EDOpeAssist.preUndoAction(pGantt._page, "Gantt Option");
                EDOpeAssist.startOperator(pGantt, eMsgType.Size);
                let nHour = 0,
                    nMinute = 0,
                    nSMinutes = 0,
                    nEMinutes = 0;
                let dSDate = 0,
                    dEDate = 0,
                    isDate = false;
                let sTimes = this.StartTimeName.split(":");
                let outline = pGantt.outline2();
                if (sTimes.length === 2) {
                    nHour = parseInt(sTimes[0]);
                    nMinute = parseInt(sTimes[1]);
                    nSMinutes = nHour * 60 + nMinute;
                }
                let eTimes = this.EndTimeName.split(":");
                if (eTimes.length === 2) {
                    nHour = parseInt(eTimes[0]);
                    nMinute = parseInt(eTimes[1]);
                    nEMinutes = nHour * 60 + nMinute;
                }
                console.log("OK--------this.showStartDateName", this.showStartDateName);
                [dSDate, isDate] = EDFormat.daysFromDateString(this.showStartDateName);
                [dEDate, isDate] = EDFormat.daysFromDateString(this.showEndDateName);

                dSDate = Math.floor(dSDate);
                dEDate = Math.floor(dEDate);

                let bDurChange = pGantt._nSMinutes != nSMinutes || pGantt._nEMinutes != nEMinutes ? true : false;
                let bSetDate = pGantt.setGanttDate(
                    dSDate,
                    dEDate,
                    this.MajorNum,
                    this.MinorNum + 1,
                    nSMinutes,
                    nEMinutes,
                    pGantt._eMinor === this.MinorNum + 1 ? false : true
                );
                let bSetWorDays = pGantt.setWorkingDays(bWdays);
                let bSetFmt = false;

                if (bSetWorDays) {
                    pGantt.updateTaskSDate();
                }

                if (bSetDate || bSetWorDays) {
                    pGantt.updateGantt(bDurChange);
                }
                // 转换为底层解析的货币格式：#,###00.00
                let convertStr = this.FormatName.replace("1,980.00", "#,###0.00");
                bSetFmt = pGantt.updateFormat(
                    this.map_DateFormatName,
                    this.map_DurationFormatName,
                    this.PercentFormatName,
                    convertStr,
                    this.UnitName
                );
                pGantt.updateTodayLinePoX();

                EDOpeAssist.updateOperateData();
                EDOpeAssist.finishOperator();
                if (bDurChange || bSetDate || bSetWorDays || bSetFmt) {
                    outline = outline.unite(pGantt.outline2());
                    if (pGantt._page) {
                        pGantt._page.update(outline);
                        window["_view"]._tool.updateOperatingCpts();
                        //pGantt.page().placeShapeIntoBSP([pGantt]);
                        window["_view"].invalidate(pGantt._page.extendPageBreaks());
                    }
                    EDOpeAssist.addUndoAction();
                } else {
                    EDOpeAssist.clearUndoAction();
                }
            }
            this.closeModal();
        }
        cancel() {
            // 取消行列选择
            this.WorkingDayBoolean = this.initWorkingDayBoolean.slice(0); // 根据备份数组还原
            this.WorkingDay = [];
            for (var i = 0; i < this.WorkingDayBoolean.length; i++) {
                if (this.WorkingDayBoolean[i]) {
                    this.WorkingDay.push(this.WorkingDayList[i]);
                }
            }
        }
        selectMajor(name) {
            this.MajorNum = name;
            this.MajorName = this.DataUnitList[name];
        }
        selectWorkingDay() {
            this.WorkingDay = [];
            for (var i = 0; i < this.WorkingDayBoolean.length; i++) {
                if (this.WorkingDayBoolean[i]) {
                    this.WorkingDay.push(this.WorkingDayList[i]);
                }
            }
        }
        selectMinor(name) {
            this.MinorNum = name;
            this.MinorName = this.DataUnitListTwo[name];
            switch (this.MinorName) {
                case "Hour":
                    this.selectMajor(4);
                    break;
                case "Day":
                    this.selectMajor(2);
                    break;
                case "Week":
                    this.selectMajor(2);
                    break;
                case "Month":
                    this.selectMajor(0);
                    break;
                case "Quarter":
                    this.selectMajor(0);
                    break;
                case "HalfYear":
                    this.selectMajor(0);
                    break;
                default:
                    break;
            }
        }
        selectDateFormat(name) {
            this.DateFormatNum = name;
            this.DateFormatName = this.DateFormatList[name];
            this.map_DateFormatName = this.map_DateFormatList[name];
        }
        selectPercentFormat(name) {
            this.PercentFormatNum = name;
            this.PercentFormatName = this.PercentFormatList[name];
        }
        selectDurationFormat(name) {
            this.DurationFormatNum = name;
            this.DurationFormatName = this.DurationFormatList[name];
            this.map_DurationFormatName = this.map_DurationFormatList[name];
        }
        selectStartDate(name) {
            this.StartDateName = name;
            this.showStartDateName = name;
        }
        selectEndDate(name) {
            this.EndDateName = name;
            this.showEndDateName = name;
        }
        selectStartTime(name) {
            this.StartTimeName = name;
        }
        selectEndTime(name) {
            this.EndTimeName = name;
        }
        selectUnit(name) {
            this.UnitNum = name;
            if (name == 0) {
                this.UnitName = "None";
                this.FormatList = ["1,980.00", "0.00"];
                this.FormatNum = 0;
                this.FormatName = this.FormatList[this.FormatNum];
            } else {
                this.UnitName = this.FormatList_Text[name - 1];
                this.FormatList = [
                    `"${this.FormatList_Symbol[unitType[this.UnitName] - 1]}" 1,980.00`,
                    `"${this.FormatList_Text[unitType[this.UnitName] - 1]}" 1,980.00`,
                    `1,980.00 "${this.FormatList_Text[unitType[this.UnitName] - 1]}"`,
                    `1,980.00 "${this.FormatList_Name[unitType[this.UnitName] - 1]}"`,
                    `"${this.FormatList_Symbol[unitType[this.UnitName] - 1]}" 1980.00`,
                    `"${this.FormatList_Text[unitType[this.UnitName] - 1]}" 1980.00`,
                    `1980.00 "${this.FormatList_Text[unitType[this.UnitName] - 1]}"`,
                    `"${this.FormatList_Name[unitType[this.UnitName] - 1]}" 1980.00`,
                ];
                this.FormatName = this.FormatList[this.FormatNum];
            }
        }
        selectFormat(name) {
            this.FormatNum = name;
            this.FormatName = this.FormatList[name];
        }
        get currencyName() {
            return this.renderUnitList[unitType[this.UnitName]];
        }
        get formatName() {
            return this.FormatName.replace("#,###0.00", "1980.00");
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        keyboardEvent(e) {
            if (e.keyCode == 27) {
                // esc
                this.closeModal();
            }
        }

        mounted() {
            var mouth = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
            var mouthtwo = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
            var mouthEN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var mouthtwoEN = [
                "january",
                "february",
                "march",
                "april",
                "may",
                "june",
                "july",
                "august",
                "september",
                "october",
                "november",
                "december",
            ];
            var week = ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"];
            var weekEN = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
            var date = new Date();
            var yyyy = date.getFullYear();
            var M = date.getMonth() + 1;
            var d = date.getDate();
            var weekd = date.getDay();
            var h = date.getHours();
            var m = date.getMinutes();
            var s = date.getSeconds();
            var ap = h > 12 ? "pm" : "am";
            var yy = yyyy.toString().substring(2);
            var MM = M < 10 ? "0" + M : M;
            var dd = d < 10 ? "0" + d : d;
            var hh = h < 10 ? "0" + h : h;
            var mm = m < 10 ? "0" + m : m;
            var ss = s < 10 ? "0" + s : s;
            var MMMM = mouthEN[M - 1];
            var dddd = weekEN[weekd - 1];
            var MMM = mouthEN[M - 1];
            this.DateFormatList = [
                `${yyyy}-${MM}-${dd}`,
                `${yyyy}/${M}/${d}`,
                `${M}/${d}/${yyyy}`,
                `${M}/${d}/${yy}`,
                `${d}/${M}/${yyyy}`,
                `${d}/${M}/${yy}`,
                `${M}.${d}.${yyyy}`,
                `${d}.${M}.${yyyy}`,
                `${yy}-${M}-${d}`,
                `${MM}-${dd}-${yy}`,
                `${MMMM} ${d},${yyyy}`,
                `${dddd},${MMMM} ${dd},${yyyy}`,
                `${d} ${MMMM} ${yyyy}`,
                `${d}-${MMM}-${yy}`,
                `${MMM}.${d},${yy}`,
                // `${MMMM} ${yy}`,
                // `${MMM}-${yy}`,
                // `${yyyy}`,
                // `${MMM}`,
                `${M}/${d}/${yyyy} ${h}:${MM} ${ap}`,
                `${M}/${d}/${yyyy} ${h}:${MM} ${ap}`,
                `${d}/${M}/${yyyy} ${h}:${MM} ${ap}`,
                `${d}/${M}/${yyyy} ${h}:${MM} ${ap}`,
                // `${h}:${MM} ${ap}`,
                // `${h}:${MM} ${ap}`,
                // `${hh}:${MM}`,
                // `${hh}:${MM}`,
                // `${hh}`,
                // `${MM}`,
            ];
            this.showBox();
            console.log(this.DateFormatList);
        }
        created() {
            let arr = window["_view"].getGanttExceptDate();
            for (let i = 0; i < arr.length; i++) {
                let obj = {
                    otherdays_name: arr[i][0],
                    otherdays_start: arr[i][1],
                    otherdays_end: arr[i][2],
                };
                arr[i] = obj;
            }
            this.ganttOtherDaysData = JSON.parse(JSON.stringify(arr));
            document.addEventListener("keydown", this.keyboardEvent);
        }

        beforeDestroy() {
            document.removeEventListener("keydown", this.keyboardEvent);
        }
    }
</script>
<i18n>
{
  "zh": {
    "to":"至",
    "tips1": "设置整个任务的开始和结束日期",
    "tips2": "设置每周的工作日及每天的工作时间，任务将按照此时间来计算",
    "tips3": "添加例如补班日等例外日期，任务将按照工作时间+例外日期的方式来计算",
    "tips4": "设置全局格式，新增的列将按照下列设置来展示",
    "tips5": "设置任务右侧图形区的日历视图单位，日历将按照此单位来展示",
    "title": "甘特图全局设置",
    "dateUnit": "日历视图单位",
    "projectDuration": "起止日期",
    "majorUnit": "主单位",
    "minorUnit": "次单位",
    "workingDays": "工作时间",
    "setOtherDays": "添加例外日期",
    "Monday": "星期一",
    "Tuesday": "星期二",
    "Wednesday": "星期三",
    "Thursday": "星期四",
    "Friday": "星期五",
    "Saturday": "星期六",
    "Sunday": "星期天",
    "format": "格式",
    "dateFormat": "日期格式",
    "percentFormat": "百分比格式",
    "durationFormat": "持续时间格式",
    "startDate": "开始日期",
    "finishDate": "结束日期",
    "startTime": "开始时间",
    "finishTime": "结束时间",
    "currencyFormat": "货币格式",
    "currencyUnit": "货币单位",
    "Year": "年",
    "HalfYear": "年",
    "Quarter": "季",
    "Month": "月",
    "Week": "周",
    "Day": "日",
    "Hour": "小时",
    "1.2 w.": "1.2周",
    "1 w. 1 d.": "1周1天",
    "8.2 d.": "8.2天",
    "8 d. 5 h.": "8天5小时",
    "197 h.": "197小时",
    "197.5 h.": "197.5小时",
    "Select time": "选择时间",
    "addRow": "增加行",
    "deleteRow": "删除行",
    "AUD": "澳大利亚元",
    "CAD": "加元",
    "DKK": "丹麦克朗",
    "EUR": "欧元",
    "HKD": "港元",
    "JPY": "日元",
    "GBP": "英镑",
    "SEK": "瑞典克朗",
    "USD": "美元",
    "CNY": "元",
    "INR": "卢比",
    "KRW": "韩元",
    "MYR": "马元",
    "MXN": "墨西哥比索",
    "ZAR": "兰特"
  },
  "en": {
    "to":"to",
    "tips1": "Set start and end dates for the entire task",
    "tips2": "Set the working days of each week and the working hours of each day; the task will be calculated according to this time.",
    "tips3": "Add exception dates such as make-up days, and the task will be calculated by working time and exception date",
    "tips4": "Set the overview and the new column will be displayed according to the following settings",
    "tips5": "Set the unit of the calendar view and the calendar will be displayed according to this unit.",
    "title": "Gantt Chart View",
    "dateUnit": "Calendar View",
    "projectDuration": "start and end date",
    "majorUnit": "Major Unit",
    "minorUnit": "Minor Unit",
    "workingDays": "Working days",
    "setOtherDays": "Add Exception Days",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "Sunday": "Sunday",
    "format": "Format",
    "dateFormat": "Date Format",
    "percentFormat": "Percentage Format",
    "durationFormat": "Duration Format",
    "startDate": "Start Date",
    "finishDate": "End Date",
    "startTime": "Start Time",
    "finishTime": "End Time",
    "currencyFormat": "Currency Format",
    "currencyUnit": "Currency Unit",
    "Year": "Year",
    "HalfYear": "Year",
    "Quarter": "Quarter",
    "Month": "Month",
    "Week": "Week",
    "Day": "Day",
    "Hour": "Hour",
    "1.2 w.": "1.2 week",
    "1 w. 1 d.": "1 week 1 day",
    "8.2 d.": "8.2 days",
    "8 d. 5 h.": "8 days 5 hour",
    "197 h.": "197 hour",
    "197.5 h.": "197.5 hour",
    "Select time": "Select time",
    "addRow": "Add a row",
    "deleteRow": "Delete a row",
    "AUD": "Australian Dollar",
    "CAD": "Canadian Dollar",
    "DKK": "Danish Krone",
    "EUR": "Euro",
    "HKD": "Hong Kong Dollar",
    "JPY": "Japanese yen",
    "GBP": "Pound Sterling",
    "SEK": "Swedish Krona",
    "USD": "US Dollar",
    "CNY": "Yuan Renminbi",
    "INR": "Indian Rupee",
    "KRW": "South Korean Won",
    "MYR": "Malaysian Ringgit",
    "MXN": "Mexican Peso",
    "ZAR": "South African Rand"
  },
  "de": {
    "tips1": "Start- und Enddatum für die gesamte Aufgabe festlegen",
    "tips2": "Legen Sie die Arbeitstage jeder Woche und die Arbeitsstunden eines jeden Tages fest. Die Aufgabe wird entsprechend dieser Zeit berechnet.",
    "tips3": "Fügen Sie Ausnahmedaten wie Ausgleichstage hinzu und die Aufgabe mithilfe der Arbeitszeit und dem Ausnahmedatum berechnet.",
    "tips4": "Legen Sie die Übersicht fest und die neue Spalte wird entsprechend der folgenden Einstellungen angezeigt.",
    "tips5": "Legen Sie die Einheit für die Kalenderansicht fest und der Kalender wird entsprechend dieser Einheit angezeigt.",
    "title": "Gantt-Diagrammansicht",
    "dateUnit": "Kalenderansicht",
    "projectDuration": "Start- und Enddatum",
    "majorUnit": "Haupteinheit",
    "minorUnit": "Kleinste Einheit",
    "workingDays": "Arbeitstage",
    "setOtherDays": "Ausnahmetage hinzufügen",
    "Monday": "Montag",
    "Tuesday": "Dienstag",
    "Wednesday": "Mittwoch",
    "Thursday": "Donnerstag",
    "Friday": "Freitag",
    "Saturday": "Samstag",
    "Sunday": "Sonntag",
    "format": "Format",
    "dateFormat": "Datumsformat",
    "percentFormat": "Prozentformat",
    "durationFormat": "Dauerformat",
    "startDate": "Startdatum",
    "finishDate": "Enddatum",
    "startTime": "Startzeit",
    "finishTime": "Endzeit",
    "currencyFormat": "Währungsformat",
    "currencyUnit": "Währungseinheit",
    "Year": "Jahr",
    "HalfYear": "Jahr",
    "Quarter": "Jahreszeit",
    "Month": "Monat ",
    "Week": "Woche",
    "Day": "Tag",
    "Hour": "Stunde",
    "1.2 w.": "1.2 Woche",
    "1 w. 1 d.": "1 Woche 1 Day",
    "8.2 d.": "8.2 Day",
    "8 d. 5 h.": "8 Day 5 Stunde",
    "197 h.": "197 Stunde",
    "197.5 h.": "197.5 Stunde",
    "Select time": "Auswahlzeitraum",
    "addRow": "Zeile hinzufügen",
    "deleteRow": "Zeile löschen",
    "AUD": "Australischer Dollar",
    "CAD": "Kanadischer Dollar",
    "DKK": "Dänenkrone",
    "EUR": "Euro",
    "HKD": "Hongkong-Dollar",
    "JPY": "Yen",
    "GBP": "Pfund Sterling",
    "SEK": "Schwedische Krone",
    "USD": "US Dollar",
    "CNY": "Yuan Renminbi",
    "INR": "Indischen Rupie",
    "KRW": "Südkoreanischer Won",
    "MYR": "Ringgit",
    "MXN": "Mexikanischer Peso",
    "ZAR": "üdafrikanischer Rand"
  },
  "es": {
    "tips1": "Establece las fechas de inicio y finalización de toda la tarea.",
    "tips2": "Establece los días laborables de cada semana y las horas de trabajo de cada día. La tarea se calculará en función de ese tiempo.",
    "tips3": "Añade fechas de excepción, como días de recuperación, y la tarea se calculará por tiempo de trabajo y fecha de excepción.",
    "tips4": "Configura la vista general y la nueva columna se mostrará de acuerdo con los siguientes ajustes.",
    "tips5": "Establece la unidad de la vista de calendario y el calendario se mostrará en función de dicha unidad.",
    "title": "Vista de diagrama de Gantt",
    "dateUnit": "Vista de calendario",
    "projectDuration": "Fecha de inicio y finalización",
    "majorUnit": "Unidad Mayor",
    "minorUnit": "Unidad menor",
    "workingDays": "Días de trabajo",
    "setOtherDays": "Añadir días de excepción",
    "Monday": "Lunes",
    "Tuesday": "Martes",
    "Wednesday": "Miércoles",
    "Thursday": "Jueves",
    "Friday": "Viernes",
    "Saturday": "Sábado",
    "Sunday": "Domingo",
    "format": "Formato",
    "dateFormat": "Formato de la fecha",
    "percentFormat": "Formato de porcentaje",
    "durationFormat": "Formato de duración",
    "startDate": "Fecha de inicio",
    "finishDate": "Fecha de finalización",
    "startTime": "Fecha de inicio",
    "finishTime": "Fecha de finalización",
    "currencyFormat": "Formato de la moneda",
    "currencyUnit": "Unidad monetaria",
    "Year": "Año",
    "HalfYear": "Año",
    "Quarter": "Cuarto",
    "Month": "Mes",
    "Week": "Semana",
    "Day": "Día",
    "Hour": "Hora",
    "1.2 w.": "1.2 Week",
    "1 w. 1 d.": "1 Week 1 Day",
    "8.2 d.": "8.2 Day",
    "8 d. 5 h.": "8 Day 5 Hora",
    "197 h.": "197 Hora",
    "197.5 h.": "197.5 Hora",
    "Select time": "período de selección",
    "addRow": "Añadir fila",
    "deleteRow": "Borrar fila",
    "AUD": "Dólar australiano",
    "CAD": "Dólar canadiense",
    "DKK": "Corona danesa",
    "EUR": "Euro",
    "HKD": "Dólar de Hong Kong",
    "JPY": "Yen",
    "GBP": "Libra británica",
    "SEK": "Corona sueca",
    "USD": "Dólar estadounidense",
    "CNY": "Yuan chino",
    "INR": "Rupia india",
    "KRW": "Won surcoreano",
    "MYR": "Ringgit malayo",
    "MXN": "Peso mexicano",
    "ZAR": "Rand sudafricano"
  },
  "fr": {
    "tips1": "Définissez des dates de début et de fin pour l'ensemble de la tâche",
    "tips2": "Définissez les jours ouvrables pour chaque semaine et les heures ouvrables pour chaque jour. La tâche sera calculée en fonction de ces heures.",
    "tips3": "Ajoutez des dates d'exception, comme des jours de rattrapage, et la tâche sera calculée en fonction du temps de travail et des dates d'exception.",
    "tips4": "Définissez l'aperçu et la nouvelle colonne s'affichera en fonction des paramètres suivants",
    "tips5": "Définissez l'unité de la vue du calendrier et le calendrier s'affichera en fonction de cette unité.",
    "title": "Vue Diagramme de Gantt",
    "dateUnit": "Vue Calendrier",
    "projectDuration": "Date de début et de fin",
    "majorUnit": "Unité principale",
    "minorUnit": "Sous-unité",
    "workingDays": "Jour ouvrable",
    "setOtherDays": "Ajouter des jours d'exception",
    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "Sunday": "Dimanche",
    "format": "Format",
    "dateFormat": "Format de Date",
    "percentFormat": "Format de Pourcentage",
    "durationFormat": "Format de Durée",
    "startDate": "Date de Début",
    "finishDate": "Date de Fin",
    "startTime": "Heure de Début",
    "finishTime": "Heure de Fin",
    "currencyFormat": "Format Monétaire",
    "currencyUnit": "Currency Unit",
    "Year": "Année",
    "HalfYear": "Année",
    "Quarter": "Trimestre",
    "Month": "Mois",
    "Week": "Semaine",
    "Day": "Jour",
    "Hour": "Heure",
    "1.2 w.": "1.2 Semaine",
    "1 w. 1 d.": "1 Semaine 1 Jour",
    "8.2 d.": "8.2 Jour",
    "8 d. 5 h.": "8 Jour 5 Heure",
    "197 h.": "197 Heure",
    "197.5 h.": "197.5 Heure",
    "Select time": "période de sélection",
    "addRow": "Ajouter une rangée",
    "deleteRow": "Supprimer la ligne",
    "AUD": "Dollar australien",
    "CAD": "Dollar canadien",
    "DKK": "Couronne danoise",
    "EUR": "Euro",
    "HKD": "Dollar de Hong Kong",
    "JPY": "yen Japonais",
    "GBP": "Livre sterling",
    "SEK": "Couronne suédoise",
    "USD": "Dollar US",
    "CNY": "Yuan Renminbi",
    "INR": "Roupie indienne",
    "KRW": "Won sud-coréen",
    "MYR": "Ringgit malaisien",
    "MXN": "Peso Mexicaine",
    "ZAR": "Rand sud-africain"
  },
  "it": {
    "tips1": "Imposta date di inizio e di fine per l'intera attività",
    "tips2": "Imposta i giorni lavorativi di ciascuna settimana e le ore lavorative di ciascun giorno. L'attività verrà calcolata in base a questi valori.",
    "tips3": "Aggiungi date di eccezione come i giorni di formazione. L'attività verrà calcolata in base alle ore di lavoro e alla data di eccezione",
    "tips4": "Imposta la panoramica e la nuova colonna verrà visualizzata in base alle seguenti impostazioni",
    "tips5": "Imposta l'unità della visualizzazione del calendario. Il calendario verrà visualizzato in base a tale unità.",
    "title": "Visualizzazione diagramma di Gantt",
    "dateUnit": "Visualizzazione calendario",
    "projectDuration": "Data di inizio e di fine",
    "majorUnit": "Unità Principale",
    "minorUnit": "Unità Minore",
    "workingDays": "Giorni Lavorativi",
    "setOtherDays": "Aggiungi giorni eccezione",
    "Monday": "Lunedì",
    "Tuesday": "Martedì",
    "Wednesday": "Mercoledì",
    "Thursday": "Giovedì",
    "Friday": "Venerdì",
    "Saturday": "Sabato",
    "Sunday": "Domenica",
    "format": "Formato",
    "dateFormat": "Formato Data",
    "percentFormat": "Formato Percentuale",
    "durationFormat": "Formato Durata",
    "startDate": "Data di Inizio",
    "finishDate": "Data di Fine",
    "startTime": "Ora di Inizio",
    "finishTime": "Ora di Fine",
    "currencyFormat": "Formato Valuta",
    "currencyUnit": "Unità Valuta",
    "Year": "Anno",
    "HalfYear": "Anno",
    "Quarter": "Trimestre",
    "Month": "Mese",
    "Week": "Settimana",
    "Day": "Giorno",
    "Hour": "Ora",
    "1.2 w.": "1.2 Settimana",
    "1 w. 1 d.": "1 Settimana 1 Giorno",
    "8.2 d.": "8.2 Giorno",
    "8 d. 5 h.": "8 Giorno 5 Ora",
    "197 h.": "197 Ora",
    "197.5 h.": "197.5 Ora",
    "Select time": "periodo di selezione",
    "addRow": "Aggiungi riga",
    "deleteRow": "Elimina riga",
    "AUD": "Dollaro australiano",
    "CAD": "Dollaro canadese",
    "DKK": "Corona danese",
    "EUR": "EUR",
    "HKD": "Dollaro di Hong Kong",
    "JPY": "Yen giapponese",
    "GBP": "Sterlina inglese",
    "SEK": "Corona svedese",
    "USD": "Dollaro statunitense",
    "CNY": "Yuan cinese",
    "INR": "Rupia indiana",
    "KRW": "Won coreano",
    "MYR": "Dollaro malese",
    "MXN": "Peso messicano",
    "ZAR": "Rand sudafricano"
  },
  "jp": {
    "tips1": "タスク全体の開始日と終了日を設定します",
    "tips2": "各週の作業日と各曜日の作業時間を設定します。タスクはこの時間によって計算されます。",
    "tips3": "振替休日などの除外日を追加すると、タスクは作業時間と除外日によって計算されます",
    "tips4": "概要を設定すると、次の設定に従って新しい列が表示されます",
    "tips5": "カレンダービューの単位を設定すると、この単位に従ってカレンダーが表示されます。",
    "title": "ガントチャートビュー",
    "dateUnit": "カレンダービュー",
    "majorUnit": "主単位",
    "projectDuration": "開始日と終了日",
    "minorUnit": "子単位",
    "workingDays": "作業日",
    "setOtherDays": "除外日を追加",
    "Monday": "月曜日",
    "Tuesday": "火曜日",
    "Wednesday": "水曜日",
    "Thursday": "木曜日",
    "Friday": "金曜日",
    "Saturday": "土曜日",
    "Sunday": "日曜日",
    "format": "書式",
    "dateFormat": "日付書式",
    "percentFormat": "パーセンテージ書式",
    "durationFormat": "期間書式",
    "startDate": "開始日",
    "finishDate": "終了日",
    "startTime": "開始時間",
    "finishTime": "終了時間",
    "currencyFormat": "通貨形式",
    "currencyUnit": "通貨単位",
    "Year": "年",
    "HalfYear": "年",
    "Quarter": "四半期",
    "Month": "月",
    "Week": "週",
    "Day": "日",
    "Hour": "時間",
    "1.2 w.": "1.2週",
    "1 w. 1 d.": "1週1日",
    "8.2 d.": "8.2天",
    "8 d. 5 h.": "8 日5 時間",
    "197 h.": "197 日",
    "197.5 h.": "197.5 時間",
    "Select time": "選考期間",
    "addRow": "行を追加する",
    "deleteRow": "行を削除する",
    "AUD": "豪ドル",
    "CAD": "カナダドル",
    "DKK": "デンマーク・クローネ",
    "EUR": "ユーロ",
    "HKD": "香港ドル",
    "JPY": "日本円",
    "GBP": "英ポンド",
    "SEK": "スウェーデン・クローナ",
    "USD": "ドル",
    "CNY": "人民幣",
    "INR": "インドルピー",
    "KRW": "韓国ウォン",
    "MYR": "マレーシアリンギット",
    "MXN": "メキシコペソ",
    "ZAR": "南アフリカランド"
  },
  "pt": {
    "tips1": "Defina as datas de início e término para toda a tarefa",
    "tips2": "Defina os dias úteis de cada semana e as horas de trabalho de cada dia. A tarefa será calculada de acordo com esse horário.",
    "tips3": "Adicione datas de exceção, como dias de reposição, e a tarefa será calculada com base na hora de trabalho e data de exceção",
    "tips4": "Defina a visão geral e a nova coluna será exibida de acordo com as seguintes configurações",
    "tips5": "Defina a unidade de exibição do Calendário e ele será exibido de acordo com esta unidade.",
    "title": "Visualização do Gráfico de Gantt",
    "dateUnit": "Exibição do Calendário",
    "projectDuration": "Data de início e término",
    "majorUnit": "Unidade Fundamental",
    "minorUnit": "Unidade Menor",
    "workingDays": "Dias de Trabalho",
    "setOtherDays": "Adicionar datas de exceção",
    "Monday": "Segunda-Feira",
    "Tuesday": "Terça-Feira",
    "Wednesday": "Quarta-Feira",
    "Thursday": "Quinta-Feira",
    "Friday": "Sexta-Feira",
    "Saturday": "Sábado",
    "Sunday": "Domingo",
    "format": "Formato",
    "dateFormat": "Formato de Data",
    "percentFormat": "Formato de Percentagem",
    "durationFormat": "Formato de Duração",
    "startDate": "Data Inicial",
    "finishDate": "Data Final",
    "startTime": "Hora Inicial",
    "finishTime": "Hora Final",
    "currencyFormat": "Formato de Moeda",
    "currencyUnit": "Unidade de Moeda",
    "Year": "Ano",
    "HalfYear": "Ano",
    "Quarter": "Trimestre",
    "Month": "Mês",
    "Week": "Semana",
    "Day": "Dia",
    "Hour": "Hora",
    "1.2 w.": "1.2 Semana",
    "1 w. 1 d.": "1 Semana 1 Dia",
    "8.2 d.": "8.2 Dia",
    "8 d. 5 h.": "8 Dia 5 Hora",
    "197 h.": "197 Hora",
    "197.5 h.": "197.5 Hora",
    "Select time": "período de seleção",
    "addRow": "Adicionar linha",
    "deleteRow": "Apagar linha",
    "AUD": "Austrália",
    "CAD": "Canadá",
    "DKK": "Dinamarca",
    "EUR": "União Europeia",
    "HKD": "Hongkong China",
    "JPY": "Japão",
    "GBP": "Reino Unido",
    "SEK": "Suécia",
    "USD": "Estados Unidos",
    "CNY": "China",
    "INR": "Índia",
    "KRW": "Coreia",
    "MYR": "Malásia",
    "MXN": "México",
    "ZAR": "África do Sul"
  },
  "tw": {
    "tips1": "設定整個工作的開始與結束日期",
    "tips2": "設定每週的工作日和每日工作時數；工作將依此時間計算。",
    "tips3": "新增例外日期，例如補班日等。工作將依工作時間和例外日期計算",
    "tips4": "設定概覽和新增的欄將根據下列設定顯示",
    "tips5": "設定行事曆檢視單位，行事曆即會依此單位顯示。",
    "title": "甘特圖檢視",
    "dateUnit": "行事曆檢視",
    "projectDuration": "起止日期",
    "majorUnit": "主單位",
    "minorUnit": "次單位",
    "workingDays": "工作日",
    "otherDays": "例外日期",
    "setOtherDays": "新增例外日",
    "Monday": "星期一",
    "Tuesday": "星期二",
    "Wednesday": "星期三",
    "Thursday": "星期四",
    "Friday": "星期五",
    "Saturday": "星期六",
    "Sunday": "星期天",
    "format": "格式",
    "dateFormat": "日期格式",
    "percentFormat": "百分比格式",
    "durationFormat": "持續時間格式",
    "startDate": "開始日期",
    "finishDate": "結束日期",
    "startTime": "開始时间",
    "finishTime": "結束时间",
    "currencyFormat": "貨幣格式",
    "currencyUnit": "貨幣單位",
    "Year": "年",
    "HalfYear": "年",
    "Quarter": "季",
    "Month": "月",
    "Week": "周",
    "Day": "日",
    "Hour": "小時",
    "1.2 w.": "1.2周",
    "1 w. 1 d.": "1周1天",
    "8.2 d.": "8.2天",
    "8 d. 5 h.": "8天5小時",
    "197 h.": "197小時",
    "197.5 h.": "197.5小時",
    "Select time": "選擇時間",
    "addRow": "增加行",
    "deleteRow": "删除行",
    "AUD": "澳大利亞元",
    "CAD": "加元",
    "DKK": "丹麥克朗",
    "EUR": "歐元",
    "HKD": "港元",
    "JPY": "日圆",
    "GBP": "英鎊",
    "SEK": "瑞典克朗",
    "USD": "美元",
    "CNY": "元",
    "INR": "卢比",
    "KRW": "韩圆",
    "MYR": "马馬元元",
    "MXN": "墨西哥比索",
    "ZAR": "蘭特"
  }
}
</i18n>
